import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Wrapper = styled.div`
  ${fonts.libreBaskerville};
  padding: 30px 0 0px 0;
`

export const FirstSection = styled.div``

export const SecondSection = styled.div`
  background-color: ${colors.light2};
`

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 39px;
  margin: 30px 0px;
  text-align: center;
`

export const Illustrations = styled.div`
  max-width: 860px;
  margin: 15px auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`

export const Illustration = styled.div`
  width: 340px;
  text-align: center;
  margin-top: 20px;
`

export const Image = styled.img`
  width: 90%;
`

export const IllustrationTitle = styled.div`
  color: ${colors.darkPurple};
  font-size: 20px;
  margin-top: 10px;
`

export const EngagementLabel = styled.div`
  max-width: 860px;
  margin: 40px auto 0 auto;
  text-align: center;
  color: ${colors.pink};
  font-size: 28px;
`

const FIRST_SECTION = [
  { image: 'payment-images-01.jpg', text: 'Thousands of interactive lessons' },
  { image: 'payment-images-02.jpg', text: 'Regular Global Competitions' }
]

const OTHER_SECTION = [
  { image: 'payment-images-03.jpg', text: 'Home and individual blogs' },
  { image: 'payment-images-04.jpg', text: 'Shareable progress report' }
]

const EngageSection = props => (
  <Wrapper>
    <FirstSection>
      <Title>Subscribing gives you access to</Title>
      <Illustrations>
        {FIRST_SECTION.map((s, i) => (
          <Illustration key={`first-${i}`}>
            <Image src={`${ASSETS_PATH}/pages/Dashboard/images/${s.image}`} />
            <IllustrationTitle>{s.text}</IllustrationTitle>
          </Illustration>
        ))}
      </Illustrations>
    </FirstSection>
    <SecondSection>
      <Illustrations>
        {OTHER_SECTION.map((s, i) => (
          <Illustration key={`second-${i}`}>
            <Image src={`${ASSETS_PATH}/pages/Dashboard/images/${s.image}`} />
            <IllustrationTitle>{s.text}</IllustrationTitle>
          </Illustration>
        ))}
      </Illustrations>
      <EngagementLabel>
      Join thousands of parents and teachers around the world dedicated to
      developing a love of writing!
      </EngagementLabel>
    </SecondSection>
  </Wrapper>
)

EngageSection.propTypes = {
  parent: PropTypes.bool
}

EngageSection.defaultProps = {
  parent: false
}

export default EngageSection
